import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiSnackbarHostComponent } from './ui-snackbar-host/ui-snackbar-host.component';
import { UiSnackbarItemComponent } from './ui-snackbar-item/ui-snackbar-item.component';

@NgModule({
  imports: [CommonModule],
  declarations: [UiSnackbarHostComponent, UiSnackbarItemComponent],
  exports: [UiSnackbarHostComponent, UiSnackbarItemComponent],
})
export class SnackbarModule {}
